import { ESearchMode } from "../types/chat";
import type {
  IIsComposerSearchModeAllowedProps,
  IIsSearchModeAllowedByOrgProps,
} from "./search-mode-org-access.types";

// NOTE: NSAI-7413 — whether the organization's Chat Settings switches allow a
// search mode, so web and mobile offer, restore and keep the same modes the
// server runs. Both search modes search the web: Web Search needs its switch,
// Deep Research needs both (NSAI-7653). NONE and AUTO need neither — Auto
// applies the switches itself on the server. The server stays the authority
// and downgrades a disallowed mode; this keeps the composer from showing one.
export const isSearchModeAllowedByOrg = ({
  searchMode,
  isWebSearchEnabled,
  isDeepResearchEnabled,
}: IIsSearchModeAllowedByOrgProps): boolean => {
  switch (searchMode) {
    case ESearchMode.WEB:
      return isWebSearchEnabled;
    case ESearchMode.DEEP:
      return isWebSearchEnabled && isDeepResearchEnabled;
    default:
      return true;
  }
};

// NOTE: NSAI-7413 — the composer's check, for settings that may not have
// loaded yet. Until they arrive nothing is known to be off, so the selected
// mode is kept; once they do, a mode the switches disallow is dropped — the
// chip a chat restored after an admin turned the feature off.
export const isComposerSearchModeAllowed = ({
  searchMode,
  chatSettings,
}: IIsComposerSearchModeAllowedProps): boolean =>
  chatSettings === null ||
  chatSettings === undefined ||
  isSearchModeAllowedByOrg({
    searchMode,
    isWebSearchEnabled: chatSettings.isWebSearchEnabled === true,
    isDeepResearchEnabled: chatSettings.isDeepResearchEnabled === true,
  });
